"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var FormattedAddress_1 = __importDefault(require("../../Client/FormattedAddress"));
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var AddressDetailsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.address'), subHeading: trans('optiiva::headings.personal') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.housing-tenure'), value: client.housing_tenure_readable || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, dropBorder: true, label: trans('optiiva::labels.address'), value: react_1.default.createElement(FormattedAddress_1.default, { client: client }) })));
};
exports.default = AddressDetailsProfile;
//# sourceMappingURL=AddressDetailsProfile.js.map